(function () {
  const CART_ADD_URL = (window.Eurus && window.Eurus.cart_add_url) || '/cart/add.js';
  const CART_UPDATE_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root + 'cart/update.js'
    : '/cart/update.js';

  function toggleWaitingBar(force) {
    document.querySelectorAll('.waiting-bar').forEach(function (bar) {
      if (force === true) bar.classList.add('is-active');
      else if (force === false) bar.classList.remove('is-active');
      else bar.classList.toggle('is-active');
    });
  }

  function toggleConfirmationBar() {
    document.querySelectorAll('.cart-green-banner').forEach(function (banner) {
      banner.classList.add('is-active');
      setTimeout(function () {
        banner.classList.remove('is-active');
      }, 2500);
    });
  }

  window.gscConfirm = function (text) {
    document.querySelectorAll('.gsc-modal').forEach(function (el) {
      el.remove();
    });

    var modal = document.createElement('div');
    modal.className = 'gsc-modal';
    modal.innerHTML =
      '<div class="gsc-modal-inner">' +
      '<div class="gsc-modal-message"></div>' +
      '<div class="gsc-modal-buttons"><a class="gsc-modal-button btn is-dark" href="#">OK</a></div>' +
      '</div>';
    modal.querySelector('.gsc-modal-message').textContent = text || '';
    modal.querySelector('.gsc-modal-button').addEventListener('click', function (event) {
      event.preventDefault();
      modal.remove();
    });
    document.body.appendChild(modal);
    return false;
  };

  window.updateCartAttributes = function (event) {
    var input = event.target;
    toggleWaitingBar(true);

    if (input.name && input.name.indexOf('E-Gift Selected') !== -1) {
      input.parentElement.classList.toggle('is-active');
    }

    var pin = String(Math.random() * 10).replace('.', '').substring(0, 4);
    var attrMatch = input.name && input.name.match(/^attributes\[(.*)\]$/);
    var payload = {};

    if (input.name === 'note') {
      payload.note = input.value.trim();
    } else if (attrMatch) {
      var attributes = {};
      attributes[attrMatch[1]] = input.type === 'checkbox'
        ? (input.checked ? input.value : '')
        : input.value.trim();
      if (input.name.indexOf('E-Gift') !== -1) {
        attributes['E-Gift PIN'] = pin;
      }
      payload.attributes = attributes;
    } else {
      payload[input.name] = input.value.trim();
    }

    fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          toggleWaitingBar(false);
        });
      })
      .catch(function (error) {
        toggleWaitingBar(false);
        window.gscConfirm((error && error.description) || 'Unable to update cart.');
      });
  };

  function getCartSections() {
    if (window.Alpine && Alpine.store('xCartHelper')) {
      return Alpine.store('xCartHelper').getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock'];
  }

  function addCartItems(items, withSections) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var payload = { items: items };
    if (withSections) payload.sections = getCartSections();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status === 422) throw data;
        return data;
      });
    });
  }

  function openMiniCartAfterAdd(response) {
    var helper = window.Alpine && Alpine.store('xCartHelper');
    var miniCart = window.Alpine && Alpine.store('xMiniCart');
    var renderPromise = helper
      ? helper.reRenderSections(response && response.sections)
      : Promise.resolve();

    return Promise.resolve(renderPromise).then(function () {
      toggleWaitingBar(false);
      if (helper) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10);
      }
      if (window.Alpine && Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
        Alpine.store('xCartNoti').setItem(response);
      } else if (miniCart) {
        miniCart.openCart();
      } else {
        window.location.href = '/cart';
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
    });
  }

  function setStep(section, step) {
    section.setAttribute('data-step', String(step));
    window.scrollTo(0, 0);
  }

  function initSizeSelector(section) {
    var selector = section.querySelector('table.size-selector') || section.querySelector('.size-selector');
    if (!selector) return;

    var isTable = selector.tagName === 'TABLE';
    var options = Array.prototype.slice.call(selector.querySelectorAll('.size-option'));
    var arrows = section.querySelectorAll('.size-selector-arrow');

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        if (isTable) {
          var cell = option.closest('td');
          var index = cell ? cell.cellIndex : 0;
          options.forEach(function (el) {
            el.classList.remove('active');
          });
          selector.querySelectorAll('tr').forEach(function (row) {
            var match = row.children[index] && row.children[index].querySelector('.size-option');
            if (match) match.classList.add('active');
          });
        } else {
          options.forEach(function (el) {
            el.classList.remove('active');
          });
          option.classList.add('active');
        }
      });
    });

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var isNext = arrow.classList.contains('is-next');
        if (isTable) {
          var active = selector.querySelector('tr td .size-option.active');
          var cell = active && active.closest('td');
          var index = cell ? cell.cellIndex : 0;
          var nextIndex = isNext ? index + 1 : index - 1;
          var firstRow = selector.querySelector('tr');
          if (firstRow && firstRow.children[nextIndex]) {
            var nextOption = firstRow.children[nextIndex].querySelector('.size-option');
            if (nextOption) nextOption.click();
          }
        }
      });
    });
  }

  function initServingsSelector(section) {
    section.querySelectorAll('.custom-selector').forEach(function (selector) {
      var value = selector.querySelector('.custom-selector-value');
      selector.querySelectorAll('.custom-selector-options li').forEach(function (item) {
        item.addEventListener('click', function () {
          value.textContent = item.textContent;
          selector.classList.add('force-close');
          setTimeout(function () {
            var next = section.querySelector('#build-navigation .btn-next');
            if (next) next.click();
            selector.classList.remove('force-close');
          }, 500);
        });
      });
    });
  }

  function initAddons(section) {
    section.querySelectorAll('.addon-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-highlighted');
      });
    });
  }

  function initWizard(section) {
    if (!section || section.dataset.owInit === 'true') return;
    section.dataset.owInit = 'true';

    var back = section.querySelector('#build-navigation .btn-back');
    var nextButtons = section.querySelectorAll('.btn-next');
    var checkout = section.querySelector('#build-navigation .btn-checkout');
    var navNext = section.querySelector('#build-navigation .btn-next');

    if (back) {
      back.addEventListener('click', function () {
        var activeStep = parseInt(section.getAttribute('data-step'), 10) || 1;
        setStep(section, Math.max(1, activeStep - 1));
        if (navNext) navNext.style.display = '';
        if (checkout) checkout.style.display = '';
      });
    }

    nextButtons.forEach(function (next) {
      next.addEventListener('click', function () {
        var activeStep = parseInt(section.getAttribute('data-step'), 10) || 1;
        var isEgift = section.getAttribute('data-egift') === 'true';
        var lastStep = isEgift ? 4 : 3;

        if (activeStep >= lastStep) return;

        setStep(section, activeStep + 1);
      });
    });

    if (checkout) {
      checkout.addEventListener('click', function () {
        var egiftToggle = section.querySelector('.e-gift input[name="attributes[E-Gift Selected]"]');
        var egiftEnabled = egiftToggle && egiftToggle.checked;
        var recipient = section.querySelector('#egift-recipient');
        var message = section.querySelector('#egift-message');

        if (egiftEnabled && recipient && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient.value.trim())) {
          return window.gscConfirm('Please enter a valid recipient email address');
        }

        if (egiftEnabled && message && message.value.trim().length < 5) {
          return window.gscConfirm('Please enter a valid message');
        }

        var dinnerEl = section.querySelector('.custom-selector .custom-selector-value');
        var dinnerSize = dinnerEl
          ? dinnerEl.innerText.toLowerCase().replace(' people', '').trim()
          : '2';
        var activeSize = section.querySelector('.size-option.active');
        if (!activeSize) {
          return window.gscConfirm('Please choose a claw size');
        }

        var variantId = parseInt(activeSize.getAttribute('data-variantid-' + dinnerSize) || activeSize.getAttribute('data-variantid'), 10);
        if (!variantId) {
          return window.gscConfirm('Please choose a claw size');
        }

        var extraIds = [];
        var primaryItems = [{ id: variantId, quantity: 1 }];

        section.querySelectorAll('.addon-btn.is-highlighted').forEach(function (btn) {
          var extraId = parseInt(btn.getAttribute('data-variantid'), 10);
          if (extraId) {
            extraIds.push(extraId);
            primaryItems.push({ id: extraId, quantity: 1 });
          }
        });

        var crackingService = section.querySelector('.cracking-service');
        if (crackingService && crackingService.checked) {
          var crackingId = parseInt(crackingService.getAttribute('data-variantid'), 10);
          if (crackingId) primaryItems.push({ id: crackingId, quantity: 1 });
        }

        var mustardId = parseInt(section.getAttribute('data-mustard-id'), 10);
        var bibId = parseInt(section.getAttribute('data-bib-id'), 10);
        var complimentaryItems = [];

        if (mustardId && extraIds.indexOf(mustardId) === -1) {
          complimentaryItems.push({
            id: mustardId,
            quantity: Math.max(1, parseInt(dinnerSize, 10) / 2)
          });
        }
        if (bibId && extraIds.indexOf(bibId) === -1) {
          complimentaryItems.push({ id: bibId, quantity: 1 });
        }

        toggleWaitingBar(true);

        addCartItems(primaryItems, !complimentaryItems.length)
          .then(function (response) {
            if (!complimentaryItems.length) return response;
            return addCartItems(complimentaryItems, true).catch(function (error) {
              console.warn('Order Wizard skipped complimentary items', error);
              return response;
            });
          })
          .then(function (response) {
            return openMiniCartAfterAdd(response);
          })
          .catch(function (error) {
            toggleWaitingBar(false);
            window.gscConfirm((error && error.description) || 'Unable to add items to cart.');
          });
      });
    }

    initSizeSelector(section);
    initServingsSelector(section);
    initAddons(section);
  }

  function boot(root) {
    var section = root && root.id === 'build-your-feast'
      ? root
      : (root || document).querySelector('#build-your-feast');
    if (section) initWizard(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = target.id === 'build-your-feast'
      ? target
      : target.querySelector('#build-your-feast');
    if (section) {
      section.dataset.owInit = '';
      boot(section);
    }
  });
})();
